import React from "react";
import {
  Badge,
  Link,
  Popover,
  PopoverTrigger,
  PopoverSurface,
  Text,
  makeStyles,
  tokens,
  typographyStyles,
} from "@fluentui/react-components";
import { useGetVersionQuery } from "src/api/server-api";
import { VersionPopover } from "src/components";
import "./Toolbar.css";

const useStyles = makeStyles({
  popoverSurface: {
    backgroundColor: tokens.colorNeutralBackgroundInverted,
    maxWidth: "285px",
    padding: tokens.spacingHorizontalL,
  },
  link: typographyStyles.body1,
  title: typographyStyles.subtitle1,
});

interface ToolbarProps {
  onAbout?: () => void;
  showAbout?: boolean;
  showVersion?: boolean;
}

export const Toolbar: React.FC<ToolbarProps> = ({
  onAbout,
  showAbout = true,
  showVersion = true,
}) => {
  const styles = useStyles();
  const { data: versionData } = useGetVersionQuery(undefined, { skip: !showVersion });

  return (
    <div className="toolbar">
      <div className="toolbar__frame1">
        <Text className={styles.title}>Styling Assistant</Text>
        <Popover
          positioning={{
            align: "center",
            offset: 16,
            position: "below",
          }}
          size="small"
          trapFocus={false}
        >
          <PopoverTrigger disableButtonEnhancement>
            <Badge
              appearance="filled"
              className="toolbar__badge"
              color="brand"
              shape="rounded"
              size="small"
            >
              {versionData?.version ?? "Beta"}
            </Badge>
          </PopoverTrigger>
          <PopoverSurface className={styles.popoverSurface}>
            <VersionPopover version={versionData?.version} />
          </PopoverSurface>
        </Popover>
      </div>
      {showAbout && onAbout && (
        <Link className={styles.link} onClick={onAbout}>
          About
        </Link>
      )}
    </div>
  );
};
